import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { buildUrl } from '../../utils/helper';
/**
 * Edit boolean cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const EditBooleanCell = ({ getColumns }) => {
  class EditBooleanCell extends React.Component {

    handleChange = (e) => {
      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value
      });
    }

    render() {
      const { dataItem, field } = this.props;
      const column = getColumns().find(item => item.field === field)
      const dataValue = _.get(dataItem, field) === null ? '' : _.get(dataItem, field);
      const className = (dataItem.inEdit ? "k-grid-edit-cell " : "") + this.props.className;

      const trueText = column.TrueText || 'áno';
      const falseText = column.FalseText || 'nie';
      const localizedData = [
        { text: trueText, value: true },
        { text: falseText, value: false },
      ];

      let content = null;
      if (field && field.toLowerCase() === 'zrus' && !column.TrueText && !column.FalseText) {
        if (dataValue) {
          content = (
            <img width="20" height="20" src={buildUrl('assets/icons/toolbar_cg_cancel.svg')} alt='zrus' />
          );
        }
      }
      else {
        content = dataValue ? trueText : falseText;
      }

      const td = (
        <td colSpan={this.props.colSpan}
          className={className}
          style={this.props.style}
          role="gridcell"
          aria-colindex={(this.props.columnIndex || 0) - (this.props.level || 0) + 1}
          aria-selected={false}
          tabIndex="0"
        >
          {((dataItem.inEdit === true || dataItem.inEdit === field) && column.editable !== false) ? (
            <DropDownList
              onChange={this.handleChange}
              value={localizedData.find(c => c.value === dataValue)}
              data={localizedData}
              textField="text"
            />
          ) : content}
        </td>
      );

      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }

  EditBooleanCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func
  }

  return EditBooleanCell
}